import i18n from '../i18n';

export const TICKET_STATUSES = [
  { value: 'new', label: i18n.t('tickets.statusCounts.new', 'New') },
  { value: 'processing', label: i18n.t('tickets.statusCounts.processing', 'Processing') },
  { value: 'resolved', label: i18n.t('tickets.statusCounts.resolved', 'Resolved') },
  { value: 'closed', label: i18n.t('tickets.statusCounts.closed', 'Closed') }
] as const;

export const TICKET_SOURCES = [
  { value: 'email', label: i18n.t('tickets.sources.email', 'Email') },
  { value: 'phone', label: i18n.t('tickets.sources.phone', 'Phone') },
  { value: 'chat', label: i18n.t('tickets.sources.chat', 'Chat') },
  { value: 'web', label: i18n.t('tickets.sources.web', 'Web Portal') }
] as const;

export const support_groups = [
  { value: 'techops', label: i18n.t('tickets.groups.techops', 'TechOps') },
  { value: 'backops', label: i18n.t('tickets.groups.backops', 'BackOps') },
  { value: 'biller', label: i18n.t('tickets.groups.biller', 'Biller Support') }
] as const;

export const TICKET_TYPES = [
  { value: 'request', label: i18n.t('tickets.types.request', 'Request') },
  { value: 'complaint', label: i18n.t('tickets.types.complaint', 'Complaint') }
] as const;

export const TICKET_PRIORITIES = [
  { value: 'low', label: i18n.t('tickets.low', 'Low') },
  { value: 'medium', label: i18n.t('tickets.medium', 'Medium') },
  { value: 'high', label: i18n.t('tickets.high', 'High') },
  { value: 'urgent', label: i18n.t('tickets.urgent', 'Urgent') }
] as const;

export const TICKET_CATEGORIES = [
  { value: 'technical', label: i18n.t('tickets.categories.technical', 'Technical') },
  { value: 'billing', label: i18n.t('tickets.categories.billing', 'Billing') },
  { value: 'feature', label: i18n.t('tickets.categories.feature', 'Feature') },
  { value: 'account', label: i18n.t('tickets.categories.account', 'Account') },
  { value: 'other', label: i18n.t('tickets.categories.other', 'Other') }
] as const;
